/** @jsxImportSource @emotion/react */
import React from 'react';
import Calculator from './Calculator';

const CalculatorWrapper = ({ isOpen, onClose }) => {
    return <Calculator isOpen={isOpen} onClose={onClose} />;
};

export default CalculatorWrapper;
